<template>
    <!--
        The design's new-password card. The five rules are always on show rather than
        only after a failed attempt; the checks and the reset call are unchanged.
    -->
    <div class="auth">
        <div class="auth-card">
            <div class="auth-head">
                <h1 class="auth-title">{{ $lang.Member.NewPasswordTitle }}</h1>
                <p class="auth-subtitle">{{ $lang.Member.NewPasswordSubtitle }}</p>
            </div>

            <div class="auth-fields">
                <b-field :label="$lang.Member.Password" :type="{ 'is-danger': hasError_password }" :message="emptyWarning_password">
                    <password-input v-model="password" @input="password_check"></password-input>
                </b-field>

                <div class="auth-rules">
                    <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7}"><i class="frmIcon mdi" :class="password.length > 7 ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{ $lang.Password.Password_1 }}</p>
                    <p class="frmValidation" :class="{'frmValidation--passed' : has_uppercase }"><i class="frmIcon mdi" :class="has_uppercase ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{ $lang.Password.Password_2 }}</p>
                    <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }"><i class="frmIcon mdi" :class="has_lowercase ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{ $lang.Password.Password_3 }}</p>
                    <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="frmIcon mdi" :class="has_number ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{ $lang.Password.Password_4 }}</p>
                    <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="frmIcon mdi" :class="has_special ? 'mdi-check-circle' : 'mdi-close-circle'"></i> {{ $lang.Password.Password_5 }}</p>
                </div>

                <b-field :label="$lang.Member.Password_2" :type="{ 'is-danger': hasError_password_2 }" :message="emptyWarning_password_2">
                    <password-input v-model="password_2"></password-input>
                </b-field>
                <p v-if="hasError_password_2 || isMismatch" class="auth-mismatch">
                    <span class="mdi mdi-alert-circle-outline" aria-hidden="true"></span>{{ $lang.Member.PasswordMismatch }}
                </p>
            </div>

            <b-button class="auth-submit" type="is-primary" expanded :disabled="!canSubmit" @click="saveNewPassword">{{ $lang.Member.Password_Updt }}</b-button>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import PasswordInput from '@/components/PasswordInput.vue';

    export default {
        name: 'ForgetPassword',
        components: { PasswordInput },
        data() {
            return {
                isActive: true,  
                canPasswordChange: false,
                isUpdtBtnClicked: false,
                password: '',
                password_2: '',         
                hasError_password: false,
                emptyWarning_password: '',
                hasError_password_2: false,
                emptyWarning_password_2: '',

                has_number: false,
                has_lowercase: false,
                has_uppercase: false,
                has_special: false,
            }
        },
        computed: {
            isRulesOk() {
                return this.password.length > 7 && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
            },
            isMismatch() {
                return this.password_2 !== '' && this.password_2 !== this.password;
            },
            // As in the design: the button waits until the rules pass and the confirmation
            // is not a different password. saveNewPassword still checks everything itself.
            canSubmit() {
                return this.isRulesOk && !this.isMismatch;
            }
        },
        mounted() {
            this.$store.state.isFooterFixed = true;
        },
        methods: {
            password_check() {
                this.has_number = /\d/.test(this.password);
                this.has_lowercase = /[a-z]/.test(this.password);
                this.has_uppercase = /[A-Z]/.test(this.password);
                this.has_special = /[!@#$%^&*()+=._-]/.test(this.password);
            },                                                     
            controlPassword() {
                if (this.password.length <= 7 || !this.has_number || !this.has_lowercase || !this.has_uppercase || !this.has_special) {
                    this.hasError_password = true;
                    this.canPasswordChange = false;
                } else {
                    this.hasError_password = false;

                    if (this.password_2 != this.password) {
                        this.hasError_password_2 = true;
                        this.canPasswordChange = false;
                    } else {
                        this.hasError_password_2 = false;
                        this.canPasswordChange = true;
                    }
                }               
            },   
            saveNewPassword() {
                this.controlPassword();
                this.isUpdtBtnClicked = true;
                if (this.canPasswordChange) {
                    api.members.resetPassword(this.$route.query.memberId, this.password).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            if (res.data) {
                                this.$buefy.dialog.alert({
                                    title: '',
                                    message: this.$lang.Member.Password_Changed,
                                    confirmText: this.$lang.Menus.Okay,
                                    type: 'is-success',
                                    hasIcon: true,
                                    onConfirm: () => {
                                        this.password_old = '';
                                        this.password = '';
                                        this.password_2 = '';
                                        router.push('/LoginMember');
                                    }
                                });
                            } else {
                                // The code is used, expired or not one of ours; the page used to
                                // do nothing at all. Send the member to ask for a new link.
                                this.$buefy.dialog.alert({
                                    title: this.$lang.Member.ErrorTitle,
                                    message: this.$lang.Member.ResetLinkInvalid,
                                    confirmText: this.$lang.Menus.Okay,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    onConfirm: () => router.push('/PasswordEmail')
                                });
                            }
                        }
                    });
                }                
            }
        }
    };
</script>
